import { GameVars } from "../../../GameVars";
import { UndoContainer } from "../UndoContainer";
import { AnimatedTile } from "./AnimatedTile";
import * as Mahjong from "@ravalmatic/mahjong-engine";

export class BoardClearedAnimation extends Phaser.GameObjects.Container {

    public static currentInstance: BoardClearedAnimation;   

    private f: number;
    private boardTiles: {tile1: string, tile2: string} [];
    private animatedTiles: AnimatedTile[];
    private activated: boolean;
    private framesDelta: number;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        BoardClearedAnimation.currentInstance = this;

        this.activated = false;
        this.f = 0;
        this.framesDelta = 45;
        this.boardTiles = [];
        this.animatedTiles = [];

        const actions = GameVars.gameData.data.savedActions;

        let action = actions.pop();

        while (action) {
            if (action.type === Mahjong.ActionType.TILES_SELECTED) {
                this.boardTiles.push({tile1: action.data.tA.type, tile2: action.data.tB.type});
            }
            action = actions.pop();
        }
    }

    public update(): void {

        if (!this.activated) {
            return;
        }

        if (this.f % this.framesDelta === 0 && this.boardTiles.length > 0) {

            const tiles = this.boardTiles.shift();

            const animatedTile1 = new AnimatedTile(this.scene, tiles.tile1, UndoContainer.currentInstance.x + UndoContainer.TILE_A_POSITION_X, UndoContainer.currentInstance.y + UndoContainer.TILE_POSITION_Y);
            this.add(animatedTile1);

            const animatedTile2 = new AnimatedTile(this.scene, tiles.tile2, UndoContainer.currentInstance.x + UndoContainer.TILE_B_POSITION_X, UndoContainer.currentInstance.y + UndoContainer.TILE_POSITION_Y);
            this.add(animatedTile2);

            this.animatedTiles.push(animatedTile1);
            this.animatedTiles.push(animatedTile2);

            this.framesDelta = this.framesDelta - 5 > 5 ? this.framesDelta - 5 : 5;
        }

        this.animatedTiles.forEach((tile: AnimatedTile) => {
            tile.update();
        });

        this.f ++;
    }

    public removeTile(tile: AnimatedTile): void {

        this.animatedTiles.splice(this.animatedTiles.indexOf(tile), 1);
    }

    public activate(): void {

        this.activated = true;
    }
}
